import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Etsouservice() {
  const navigate = useNavigate();
  const [listeEtsouservice, setListEtsouservice] = useState([]);

  useEffect(() => {
    axios.get('/etsouservice').then((res) => {
      setListEtsouservice(res.data);
    });
  }, []);

  return (
    <div className="container mt-3 ">
      <div className=" bg-success p-3 ">ETABLISSEMENT / SERVICE / BUREAU </div>
      <Link to="/createtsouservice" className="btn btn-warning mt-3 mb-3">
        Créer nouveau Service ou Etablissement ou Bureau
      </Link>
      <table className="table table-border table-sm">
        <thead>
          <tr>
            <th>Ets ou Services</th>
            <th>Libelle</th>
            <th>OBSERVATION</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {listeEtsouservice.map((etsouservice, key) => {
            return (
              <tr key={key}>
                <td> {etsouservice.name} </td>
                <td> {etsouservice.libelle} </td>
                <td> {etsouservice.obs} </td>
                <td>
                  <i style={{ cursor: 'pointer' }} className="fa fa-pencil p-2" onClick={() => navigate(`/etsouservice/edit/${etsouservice.id}`)}></i>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Etsouservice;
